import React from 'react';

const Sponsor = ({ edge }) => {
	const { featuredImage, sponsor_information } = edge.node;
	const { websiteUrl } = sponsor_information;

	return (
	<article className="sponsor" tabIndex="0">
		{featuredImage &&
				<img src={featuredImage.mediaItemUrl} alt={featuredImage.altText} />
		}
		<div className="sponsor-overlay">
			<a href={websiteUrl} target="_blank" rel="noopener noreferrer" tabIndex="1">View website</a>
		</div>
	</article>
	);
};

export default Sponsor;
